export default function processOrderingImagePath(imagePath?: string) {
  if (!imagePath) {
    return undefined;
  }

  const trimmedPath = imagePath.trim();

  if (trimmedPath.startsWith('http')) {
    return trimmedPath;
  }

  // This is how we get the image path
  return `/static/img/ordering/${trimmedPath}`;
}
